import { Button } from "../ui/button";
import { Bell } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "../ui/popover";
import { Separator } from "../ui/separator";
import { TNotification, useNotificationStore } from "@/stores/notification-store";
import { useEffect } from "react";
import ProgressCard from "../cards/ProgressCard";

const NotificationBell = () => {
    const { notifications, setNotifications, setIsNotificationBellOpen, isNotificationBellOpen, clearNotifications } = useNotificationStore();
    useEffect(() => {
        const _notifications: TNotification[] = [];
        setNotifications(_notifications);
    }, [setNotifications]);
    return (
        <Popover open={isNotificationBellOpen} onOpenChange={(isOpen) => setIsNotificationBellOpen(isOpen)}>
            <PopoverTrigger asChild>
                <Button size="icon" variant="outline" className="rounded-full">
                    <Bell className="h-5 w-5" />
                </Button>
            </PopoverTrigger>
            <PopoverContent className="mr-3 w-[25rem] overflow-hidden p-0">
                <div className="px-3 py-2.5 text-sm font-semibold flex justify-between items-center">
                    <span>Notifications</span>
                    <span className="hover:underline hover:cursor-pointer text-xs font-medium" onClick={clearNotifications}>Clear</span>
                </div>
                <Separator className="my-.5 bg-muted" />
                <div className="max-h-96 overflow-y-auto">
                    {notifications.map((notification, index) => (
                        <ProgressCard
                            key={index}
                            className="rounded-none border-x-0 border-t-0 shadow-none"
                            title={notification.title}
                            description={notification.description}
                            value={notification.value}
                            total={100}
                        />
                    ))}
                </div>
                {notifications.length == 0 && <div className="p-2 py-4 text-center text-xs">No notifications</div>}
            </PopoverContent>
        </Popover>
    );
};

export default NotificationBell;
